/**
 * Check if element is present in DOM before DomContentLoaded
 * good case use for async scripts and above the fold scripts
 *
 * @param {elmenentDomReady} selector
 *
 */

export function elementDomReady(selector) {
    return new Promise((resolve, reject) => {
        let element = document.querySelector(selector);
        if (element) {
            resolve(element);
            return;
        }
        new MutationObserver((mutations, observer) => {
            mutations.forEach((mutation) => {
              let nodes = Array.from(mutation.addedNodes);
              for(let node of nodes) {
                if(node.matches && node.matches(selector)) {
                  observer.disconnect();
                  resolve(node);
                  return;
                }
              };
            });
        })
        .observe(document.documentElement, {
            childList: true,
            subtree: true
        });

    });
}

export function getComponent(component, callbackFn = null) {
    return import(/* webpackPrefetch: true, webpackChunkName: "[request]" */ `${component}`).then((module) => {
        if (module.default && typeof module.default === 'function') {
            if (callbackFn && typeof callbackFn === 'function') {
                return callbackFn(module);
            }
            
            module.default();
        }
    });
}

export function loadScript(url, config = { async: false, defer: false }) {
    return new Promise(function(resolve, reject){
		const head = document.getElementsByTagName('head')[0];
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.onload = resolve;
        script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
        script.src = url;
        if (config.async) script.async = config.async;
        if (config.defer) script.defer = config.defer;
		head.appendChild(script);
	})
}

export async function copyContent(htmlElement) {
    if (!window.ClipboardItem) {
        return legacyCopyContent(htmlElement);
    }

    try {
        const clipboardItem = new ClipboardItem({ 
            'text/plain': new Blob(
                [htmlElement.innerText], 
                { type: 'text/plain' }
            ), 
            'text/html': new Blob(
                [htmlElement.innerHTML], 
                { type: 'text/html' }
            ), 
        });
        return navigator.clipboard.write([clipboardItem]);
    } catch (err) {
        console.error('Ocorreu um erro ao copiar o conteúdo: ', err);
    }
}

export function legacyCopyContent(htmlElement) {
    if (!document.execCommand) {
        console.error('O browser não suporta o comando de copiar');
        return;
    }

    const tempInput = document.createElement('textarea');
    tempInput.value = htmlElement.innerText;
    document.body.appendChild(tempInput);
    tempInput.select();
    try {
        document.execCommand('copy');
    } catch (err) {
        console.error('Ocorreu um erro ao copiar o conteúdo: ', err);
    } finally {
        document.body.removeChild(tempInput);
    }
}
